import React from 'react'

export default function InfoIcon(props) {

    return (
        <>
            <svg width="4" height="17" viewBox="0 0 4 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.09155 7.2262V14.5207" stroke="#303332" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" />
                <path d="M0.000483762 1.99955C0.000525082 1.60405 0.117868 1.21744 0.337632 0.888606C0.557396 0.559775 0.869714 0.303492 1.23513 0.152166C1.60054 0.000841425 2.00261 -0.0387346 2.39051 0.0384502C2.77842 0.115635 3.13475 0.306108 3.4144 0.585788C3.69406 0.865468 3.88445 1.22178 3.96159 1.60969C4.03874 1.9976 3.99911 2.39969 3.84775 2.76509C3.69638 3.13049 3.44008 3.44278 3.11122 3.6625C2.78237 3.88223 2.39573 3.99952 2.00022 3.99952C1.73598 4.00537 1.47337 3.95764 1.22809 3.8592C0.982808 3.76076 0.759952 3.61365 0.573075 3.42676C0.386197 3.23986 0.239165 3.01704 0.14075 2.77175C0.0423346 2.52646 -0.00539347 2.26378 0.000483762 1.99955Z" fill="#303332" />
            </svg>
        </>
    )
}